var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-base',[_c('div',{staticClass:"q-card-small"},[_c('q-section',{attrs:{"vPadding":"40","hPadding":"40"}},[_c('h2',[_vm._v("Wachtwoord instellen")]),_vm._v(" "),_c('p',{staticClass:"py-m"},[_vm._v("Er is een e-mail naar je onderweg met de uitleg om je nieuwe wachtwoord in te stellen. Je kunt dit scherm nu afsluiten.")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }